import { action, observable, makeObservable } from 'mobx';

class ErrorStore {
  errors = '';

  constructor() {
    makeObservable(this, {
      errors: observable.ref,
      setError: action.bound,
    });
  }

  setError(value) {
    this.errors = value;
  }
}

const errorStore = new ErrorStore();

export default errorStore;
